var slice = require('../array/slice');

    /**
     * Delays the call of a function within a given context.
     */
    function timeout(fn, millis, context){

        var args = slice(arguments, 3);

        return setTimeout(function() {
            fn.apply(context, args);
        }, millis);
    }

    module.exports = timeout;





//////////////////
// WEBPACK FOOTER
// ./~/mout/function/timeout.js
// module id = 695
// module chunks = 0 1 2